import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getOrders } from "../features/orders/orderSlice";
import Loader from "../components/Loader";
import {
  HiOutlineCalendar,
  HiOutlineTicket,
  HiChevronDown,
  HiChevronUp,
  HiPrinter,
} from "react-icons/hi";

function OrderItem({ order }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handlePrintInvoice = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>RECEIPT_PROTO_${order._id.slice(-6).toUpperCase()}</title>
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;700&display=swap');
            body { 
              font-family: 'Space Grotesk', sans-serif; 
              padding: 60px; 
              color: #e2e8f0; 
              background: #0b0e14;
              line-height: 1.6;
            }
            .invoice-box {
              max-width: 800px;
              margin: auto;
              border: 1px solid #1e293b;
              padding: 40px;
              border-radius: 20px;
              background: #111827;
              box-shadow: 0 0 50px rgba(0,0,0,0.5);
              position: relative;
              overflow: hidden;
            }
            .invoice-box:before {
              content: "";
              position: absolute;
              top: 0; left: 0;
              width: 100%; height: 4px;
              background: linear-gradient(to right, #06b6d4, #8b5cf6);
            }
            .header { display: flex; justify-content: space-between; margin-bottom: 50px; }
            .logo { font-size: 32px; font-weight: 900; color: #fff; letter-spacing: -2px; font-style: italic; }
            .logo span { color: #06b6d4; }
            .invoice-details { text-align: right; }
            .invoice-details h1 { margin: 0; font-size: 40px; font-weight: 900; color: #fff; letter-spacing: -1px; }
            .invoice-details p { margin: 5px 0; font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 2px; }
            .address-section { display: flex; justify-content: space-between; margin-bottom: 50px; gap: 40px; }
            .address-box { flex: 1; }
            .address-box h3 { font-size: 10px; text-transform: uppercase; color: #06b6d4; margin-bottom: 15px; letter-spacing: 3px; font-weight: 900; }
            .address-box p { margin: 5px 0; font-size: 14px; color: #94a3b8; font-weight: 500; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 40px; }
            th { text-align: left; padding: 20px 10px; border-bottom: 1px solid #1e293b; font-size: 10px; text-transform: uppercase; color: #475569; letter-spacing: 2px; }
            td { padding: 20px 10px; border-bottom: 1px solid #1e293b; font-size: 14px; color: #f1f5f9; font-weight: 600; }
            .total-section { text-align: right; }
            .total-row { display: flex; justify-content: flex-end; gap: 60px; margin-bottom: 15px; font-size: 14px; font-weight: 700; color: #64748b; }
            .total-final { font-size: 24px; font-weight: 900; color: #06b6d4; margin-top: 10px; border-top: 1px solid #1e293b; padding-top: 20px; }
            .footer { margin-top: 80px; text-align: center; font-size: 10px; color: #475569; text-transform: uppercase; letter-spacing: 4px; padding-top: 30px; border-top: 1px solid #1e293b; }
            @media print { 
              body { background: white; color: black; padding: 20px !important; }
              .invoice-box { border: none; box-shadow: none; background: white; }
              .logo, .invoice-details h1, .total-final { color: black !important; }
              .invoice-box:before { display: none; }
              td, th { border-color: #eee; color: black !important; }
            }
          </style>
        </head>
        <body>
          <div class="invoice-box">
            <div class="header">
              <div class="logo">GAMER<span>HUB</span></div>
              <div class="invoice-details">
                <h1>MANIFEST</h1>
                <p>LOG_ID: ${order._id.slice(-8).toUpperCase()}</p>
                <p>SEQ_DATE: ${new Date(
                  order.createdAt
                ).toLocaleDateString()}</p>
                <p>STATUS: ${order.status.toUpperCase()}</p>
              </div>
            </div>

            <div class="address-section">
              <div class="address-box">
                <h3>DELIVERY_COORDINATES</h3>
                <p>${order.shippingAddress.address}</p>
                <p>${order.shippingAddress.city}, ${
      order.shippingAddress.state
    } ${order.shippingAddress.zipCode}</p>
              </div>
              <div class="address-box">
                <h3>PAYMENT_PROTOCOL</h3>
                <p>${order.paymentMethod || "Encrypted Matrix"}</p>
                <p>${order.email}</p>
              </div>
            </div>

            <table>
              <thead>
                <tr>
                  <th style="width: 60%">HARDWARE_COMPONENT</th>
                  <th style="width: 20%">QTY</th>
                  <th style="width: 20%; text-align: right">B_VAL</th>
                </tr>
              </thead>
              <tbody>
                ${order.items
                  .map(
                    (item) => `
                  <tr>
                    <td>${item.name}</td>
                    <td>01</td>
                    <td style="text-align: right">$${item.price}</td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>

            <div class="total-section">
              <div class="total-row">
                <span>SUB_LOAD:</span>
                <span>${
                  order.paymentMethod === "Store Credits"
                    ? `${(order.total * 100).toLocaleString()} PTS`
                    : `$${order.total.toFixed(2)}`
                }</span>
              </div>
              <div class="total-row">
                <span>DISPATCH:</span>
                <span>ZERO_FEE</span>
              </div>
              <div class="total-row total-final">
                <span>TOTAL:</span>
                <span>${
                  order.paymentMethod === "Store Credits"
                    ? `${(order.total * 100).toLocaleString()} PTS`
                    : `$${order.total.toFixed(2)}`
                }</span>
              </div>
            </div>

            <div class="footer">
              <p>Acquisition sequence complete // End of manifest</p>
            </div>
          </div>
          <script>
            window.onload = function() { setTimeout(() => { window.print(); window.close(); }, 500); }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="bg-white/5 backdrop-blur-2xl rounded-[2.5rem] border border-white/10 overflow-hidden hover:border-cyan-500/30 transition-all duration-500 group/card">
      {/* Header Row */}
      <div
        className="p-8 flex flex-col lg:flex-row justify-between gap-8 cursor-pointer relative"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex flex-col md:flex-row gap-12 items-start md:items-center flex-1">
          <div className="flex gap-6 items-center">
            <div className="w-16 h-16 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center text-white font-black italic shadow-2xl relative overflow-hidden group-hover/card:border-cyan-500/50 transition-colors">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-purple-500/10" />
              <span className="relative">
                #{order._id.slice(-4).toUpperCase()}
              </span>
            </div>
            <div>
              <p className="text-[10px] font-black text-gray-500 uppercase tracking-[0.3em] mb-2 italic">
                Timestamp
              </p>
              <p className="text-sm font-black text-white flex items-center gap-2 italic">
                <HiOutlineCalendar className="text-cyan-400" />
                {new Date(order.createdAt).toLocaleDateString()}
              </p>
            </div>
          </div>

          <div className="hidden sm:block">
            <p className="text-[10px] font-black text-gray-500 uppercase tracking-[0.3em] mb-2 italic">
              Extraction Value
            </p>
            <p className="text-sm font-black text-cyan-400 italic tracking-tighter uppercase">
              {order.paymentMethod === "Store Credits"
                ? `${(order.total * 100).toLocaleString()} PTS`
                : `$${order.total.toFixed(2)}`}
            </p>
          </div>

          <div className="hidden sm:block">
            <p className="text-[10px] font-black text-gray-500 uppercase tracking-[0.3em] mb-2 italic">
              Active Loadout
            </p>
            <p className="text-sm font-black text-white italic">
              {order.items.length}{" "}
              {order.items.length === 1 ? "Component" : "Components"}
            </p>
          </div>

          <div>
            <div
              className={`px-4 py-1.5 text-[9px] font-black rounded-full uppercase tracking-widest border ${
                order.status === "completed"
                  ? "bg-green-500/10 text-green-400 border-green-500/20"
                  : order.status === "pending"
                  ? "bg-amber-500/10 text-amber-400 border-amber-500/20"
                  : "bg-white/5 text-gray-400 border-white/10"
              }`}
            >
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-current animate-pulse mr-2" />
              {order.status}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4 self-end lg:self-center">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handlePrintInvoice();
            }}
            className="flex items-center gap-2 px-6 py-3 bg-white text-black hover:invert rounded-2xl text-[10px] font-black uppercase tracking-widest italic transition-all duration-300 shadow-xl shadow-cyan-500/10"
          >
            <HiPrinter className="text-lg" /> MANIFEST
          </button>

          <button
            className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${
              isExpanded
                ? "bg-cyan-500 text-black"
                : "bg-white/5 text-gray-400 border border-white/10"
            }`}
          >
            {isExpanded ? (
              <HiChevronUp className="text-xl" />
            ) : (
              <HiChevronDown className="text-xl" />
            )}
          </button>
        </div>
      </div>

      {/* Expanded Details */}
      {isExpanded && (
        <div className="p-8 border-t border-white/5 bg-white/[0.02] animate-fadeIn">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-6">
              <h4 className="text-[10px] font-black text-gray-500 uppercase tracking-[0.3em] italic">
                Inventory Breakdown
              </h4>
              <div className="space-y-4">
                {order.items.map((item, idx) => (
                  <div
                    key={idx}
                    className="flex gap-6 p-5 bg-white/5 border border-white/5 rounded-3xl hover:border-cyan-500/30 transition-all group/item"
                  >
                    <div className="w-20 h-20 bg-white/10 rounded-2xl p-3 flex items-center justify-center group-hover/item:bg-white/15 transition-colors">
                      <img
                        src={item.image}
                        alt=""
                        className="max-w-full max-h-full object-contain grayscale group-hover/item:grayscale-0 transition-all duration-500"
                      />
                    </div>
                    <div className="flex-1 flex justify-between items-center">
                      <div>
                        <p className="font-black text-white italic uppercase tracking-tighter mb-1">
                          {item.name}
                        </p>
                        <p className="text-[10px] text-gray-500 font-bold uppercase tracking-widest">
                          Comp_ID: {item.code || "ALPHA_GEN"}
                        </p>
                      </div>
                      <p className="text-lg font-black text-cyan-400 italic tracking-tighter">
                        {order.paymentMethod === "Store Credits"
                          ? `${(item.price * 100).toLocaleString()} PTS`
                          : `$${item.price}`}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-8">
              <div className="bg-white/5 rounded-[2.5rem] p-8 border border-white/10">
                <h4 className="text-[10px] font-black text-gray-500 uppercase tracking-[0.3em] italic mb-6">
                  Drop Point Matrix
                </h4>
                <div className="space-y-2">
                  <p className="text-xs font-black text-white uppercase italic tracking-widest mb-4">
                    Standard Alpha Dispatch
                  </p>
                  <p className="text-sm font-medium text-gray-400">
                    {order.shippingAddress.address}
                  </p>
                  <p className="text-sm font-medium text-gray-400">
                    {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
                    {order.shippingAddress.zipCode}
                  </p>
                </div>
              </div>

              <div className="bg-white/5 rounded-[2.5rem] p-8 border border-white/10">
                <h4 className="text-[10px] font-black text-gray-500 uppercase tracking-[0.3em] italic mb-6">
                  Security Context
                </h4>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-cyan-500/10 rounded-xl flex items-center justify-center text-cyan-400">
                    <HiOutlineTicket />
                  </div>
                  <div>
                    <p className="text-xs font-black text-white uppercase italic tracking-widest">
                      {order.paymentMethod || "Encrypted Ledger"}
                    </p>
                    <p className="text-[10px] text-gray-500 font-bold">
                      {order.email}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function MyOrders() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { orders, isLoading } = useSelector((state) => state.orders);

  useEffect(() => {
    if (user?.data?.email) {
      dispatch(getOrders(user.data.email));
    }
  }, [user, dispatch]);

  if (isLoading)
    return (
      <div className="h-screen flex items-center justify-center bg-[#0b0e14]">
        <Loader />
      </div>
    );

  return (
    <div className="min-h-screen bg-[#0b0e14] py-20 px-4 md:px-8 selection:bg-cyan-500/30 relative overflow-hidden">
      {/* Background Glows */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-cyan-500/5 rounded-full blur-[140px] pointer-events-none" />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-cyan-500/10 border border-cyan-500/20 rounded-full text-[10px] font-black text-cyan-400 uppercase tracking-widest mb-6">
            <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-ping" />
            Archive Protocol Active
          </div>
          <h1 className="text-4xl md:text-7xl font-black text-white uppercase italic tracking-tighter mb-4">
            Deployment <span className="text-cyan-400">Log</span>
          </h1>
          <p className="text-gray-500 font-bold uppercase tracking-[0.2em] text-xs max-w-lg">
            Monitor and audit all previous hardware acquisition sequences.
          </p>
        </div>

        {orders.length === 0 ? (
          <div className="bg-white/5 backdrop-blur-2xl p-24 rounded-[3rem] text-center border border-white/10 shadow-2xl">
            <HiOutlineTicket className="text-8xl text-gray-800 mx-auto mb-8 animate-pulse" />
            <h3 className="text-2xl font-black text-white uppercase italic tracking-tighter mb-4">
              Log Matrix Empty
            </h3>
            <p className="text-gray-500 font-bold uppercase tracking-widest text-sm">
              No deployment cycles recorded. Initialize acquisition to start
              logging.
            </p>
          </div>
        ) : (
          <div className="space-y-8 animate-fadeIn">
            {orders.map((order) => (
              <OrderItem key={order._id} order={order} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyOrders;
